import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TimeInput',
  props: {
    value: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    onBlur: {
      type: Function,
      default: function _default() {}
    },
    showMinutes: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hours: {
      get: function get() {
        return Math.floor(parseInt(this.value) / 60) > 0 ? Math.floor(parseInt(this.value) / 60) : null;
      },
      set: function set(hours) {
        this.$emit('input', (parseInt(hours) || 0) * 60 + (this.showMinutes ? this.minutes || 0 : 0));
      }
    },
    minutes: {
      get: function get() {
        return parseInt(this.value) % 60 > 0 ? parseInt(this.value) % 60 : null;
      },
      set: function set(minutes) {
        if (parseInt(minutes) > 59) {
          this.$emit('input', parseInt(minutes));
        } else {
          this.$emit('input', (this.hours || 0) * 60 + (this.showMinutes ? parseInt(minutes) || 0 : 0));
        }
      }
    }
  }
};